/** @jsxImportSource solid-js */
import { Icons } from "#palette/components/icons.solid";
import { classes } from "#palette/style/index";
import callistoLogo from "../../assets/Callisto_logo.png";

const currentYear = new Date().getFullYear();

function SidebarProgress(props: {
  title: string;
  subtitle: string;
  idx: number;
  currentProgress: number;
}) {
  const selected = () => props.currentProgress === props.idx;
  const completed = () => props.currentProgress > props.idx;

  const border = () =>
    selected() ? "bg-brand-100 b-t b-b b-brand-300" : "bg-transparent";
  const titleColor = () =>
    completed()
      ? "text-brand-700"
      : selected()
        ? "text-brand-900"
        : "text-brand-700";
  const subtitleColor = () =>
    completed()
      ? "text-brand-700"
      : selected()
        ? "text-brand-900"
        : "text-brand-700";
  const iconColor = () => (selected() ? "bg-brand-900" : "bg-brand-700");
  const icon = () =>
    selected() ? (
      <Icons.CircleDots
        class={classes("shrink-0 mt-1", iconColor())}
      ></Icons.CircleDots>
    ) : completed() ? (
      <Icons.CircleCheck class="bg-status-success-fg shrink-0 mt-1"></Icons.CircleCheck>
    ) : (
      <Icons.Circle
        class={classes("shrink-0 mt-1", iconColor())}
      ></Icons.Circle>
    );
  return (
    <div class={classes("flex gap-5 px-5 py-2", border())}>
      <div class="flex flex-col items-center">{icon()}</div>
      <div>
        <h1 class={classes("font-serif font-medium text-lg", titleColor())}>
          {props.title}
        </h1>
        <h2 class={classes("font-medium text-md", subtitleColor())}>
          {props.subtitle}
        </h2>
      </div>
    </div>
  );
}

export function Sidebar(props: { currentProgress: () => number }) {
  return (
    <aside class="flex-col w-96 h-screen py-8 overflow-y-auto bg-brand-0 border-r shadow border-brand-300 hidden xl:flex gap-5">
      <a
        href="https://www.projectcallisto.org/"
        class="flex text-center w-full justify-center h-40"
      >
        <img src={callistoLogo} alt="" />
      </a>
      <div class="w-full max-w-lg mx-auto grid grid-cols-1 items-center h-full mx-2 relative">
        <div class="flex flex-col gap-3">
          {/*<SidebarProgress
            title="Get Started"
            subtitle="Select your community"
            idx={1}
            currentProgress={props.currentProgress()}
          />*/}
          <SidebarProgress
            title="Get Started"
            subtitle="Verify your university email"
            idx={2}
            currentProgress={props.currentProgress()}
          />
          <SidebarProgress
            title="Create Account"
            subtitle="Set your username and password"
            idx={3}
            currentProgress={props.currentProgress()}
          />
          <SidebarProgress
            title="Setup Account Recovery"
            subtitle="In case you forget your login"
            idx={4}
            currentProgress={props.currentProgress()}
          />
          <SidebarProgress
            title="Finish Profile"
            subtitle="Enter your demographics"
            idx={5}
            currentProgress={props.currentProgress()}
          />
        </div>
        <div class="absolute bottom-0 w-full text-center">
          <p class="text-brand-900">&copy; {currentYear} Callisto</p>
          <p>
            <a href="mailto:support@projectcallisto.org" class="text-brand-900">
              support@projectcallisto.org
            </a>
          </p>
        </div>
      </div>
    </aside>
  );
}
